import React from 'react';
import styles from './IconArrowUp.module.scss';

export const COLOUR = {
	PINK: '#CA5263',
	DARK_PINK: '#8F4E6D',
	NAVY: '#072241',
	GREY: '#B0B6BA',
	DARK_RED: '#b4284c',
};
const IconArrowUp = ({ color }) => {
	return (
		<svg className={styles.size} width="16" height="11" viewBox="0 0 16 11" fill="none">
			<path
				d="M15.7422 9.36377L8.61011 1.36377L1.74219 9.06747"
				stroke={color}
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default IconArrowUp;
